<template>
  <el-row class="container">
    <el-col :span="24" class="header">
      <el-col :span="6" class="logo"><!--:class="$store.getters.collapsed?'logo-collapse-width':'logo-width'" @click.native="logClick" -->
        <img style="margin-left: -20px; width: 153px; " src="../../static/img/logo.jpg"/><!-- v-if="logBg" -->
        {{$store.getters.collapsed?sysName:""}}
      </el-col>
      <div class="mob_ser" v-bind:class="{ active: isActive, activeTwo: isActiveTwo }" ><input type="text" v-model="searchs" @keyup.enter="search"  class="inp_sech inp_sech2" placeholder="search..." ><button class="ss_btn" @click="search">搜索</button> </div>
      <el-col :span="2">
		  <!--顶部三行点击隐藏左边导航-->
       <div class="tools"  v-if="$store.getters.ismobilePhone">
        
		   <el-dropdown trigger="click">
		        <span class="el-dropdown-link">
		          <i class="fa fa-align-justify fa-lg el-dropdown-link"></i>
		        </span>
		        <el-dropdown-menu slot="dropdown" style="margin-top: -1.5%;">
		          <el-dropdown-item @click.native="tapClick(1)">倉庫一覽</el-dropdown-item>
		          <el-dropdown-item @click.native="tapClick(2)">客戶</el-dropdown-item>
		          <el-dropdown-item @click.native="tapClick(3)">行事曆</el-dropdown-item>
		        </el-dropdown-menu>
		      </el-dropdown>
		  
		  
		 <!-- <el-dropdown trigger="click">
		   
		  	  
		    <el-dropdown-menu slot="dropdown"  >
		      <el-dropdown-item divided @click.native="updpwd">修改密碼</el-dropdown-item>
		      <el-dropdown-item divided @click.native="logout">退出登錄</el-dropdown-item>
		    </el-dropdown-menu>
		  </el-dropdown> -->
		  
		  
        </div>
      </el-col>
	  
	  <div id="admin_font"  v-if="!$store.getters.ismobilePhone">
	      <el-dropdown trigger="click">
	        <template v-if="$store.getters.ismobilePhone">
	          <span class="el-dropdown-link userinfo-inner"><i class="fa fa-user-o none"/> {{staff.name}}</span>
	        </template>
	        <template v-else>
				<!--class="el-dropdown-link userinfo-inner"-->
	          <span style="margin-right: 40px;"  ><i class="fa fa-user-o none"/> {{staff.name}}</span>
	        </template>
	  
	        <el-dropdown-menu slot="dropdown" style="margin-top: -1.5%;" >
	          <el-dropdown-item divided @click.native="updpwd">修改密碼</el-dropdown-item>
	          <el-dropdown-item divided @click.native="logout">退出登錄</el-dropdown-item>
	        </el-dropdown-menu>
	      </el-dropdown>
	    </div>
	  <div  v-if="!$store.getters.ismobilePhone"><!-- class="tabsbg"  id="faart" -->
	    <template v-for="tab in tabs">
	          <span style="margin-right:10px;display: inline-block;   position: relative;">
	          <el-button @click="toTab(tab)" size="medium" :type="$route.name==tab.name?'primary':'info'">{{tab.name}}</el-button>
			  <!-- <i class="el-icon-error" @click="colseTab(tab.name)" v-if="$route.name!=tab.name" style="position: absolute;right: -8px;top: -4px;"></i> -->
			          <!--v-if="$route.name!=tab.name"-->
					   <img  @click="colseTab(tab.name)" v-if="tab.name!=indexTabName"  style="width: 12px; height: 12px; position: absolute;right: -5px;top: 19px;color: red;" src="../../static/img/closeX.png"></img>
	          </span>
	    </template>
		
	  </div> 
	  
      <el-col :span="16" class="topmenu">

          <!-- 手机登录 -->
          <div class="el-dropdown" v-if="$store.getters.ismobilePhone">
            <input type="text" v-model="searchs" @keyup.enter="search"  class="inp_sech none" placeholder="search..." style="position: relative">
           <!-- <i style="" class="sec_icon"><img @click="mobSer" src="../assets/search.png" /></i> -->
          </div>
        

      <div id="phoneAdmin_font" v-if="$store.getters.ismobilePhone" >
         
		 
		  <el-dropdown trigger="click">
            <template >
				
            <span class="el-dropdown-link userinfo-inner"><i class="fa fa-user-o none"/> {{staff.name}}<i class="el-icon-arrow-down"/></span>
           <!-- <img style="float: left;" src="../assets/icon_jiantou.png"/> -->
			</template>
          

            <el-dropdown-menu slot="dropdown" style="margin-top:-20px;margin-left: -130px;" >
              <el-dropdown-item divided @click.native="updpwd">修改密碼</el-dropdown-item>
              <el-dropdown-item divided @click.native="logout">退出登錄</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-col>
    </el-col>
    <!-- 修改密碼彈出框-->
    <el-dialog title="修改密碼"  :visible.sync="dialogFormVisible" width="400px">
      <el-form :model="homeForm"  size="small"  ref="homeForm" label-width="120px">
        <el-form-item label="輸入新密碼" prop="password">
          <el-input type="password"  v-model="homeForm.password"  auto-complete="off" widht="160px" placeholder="請輸入新密碼"></el-input>
        </el-form-item>
        <el-form-item label="確認新密碼" label-width="120px" prop="confirmPassword">
          <el-input type="password" v-model="homeForm.confirmPassword"  auto-complete="off"  widht="160px" placeholder="請確認新密碼"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"  icon="el-icon-check" @click="modifyStaffPassword(homeForm)" plain>確 定</el-button>
          <el-button @click="dialogFormVisible = false" icon="el-icon-delete" plain>取 消</el-button>
        </el-form-item>
      </el-form>

      <!--<div slot="footer" class="dialog-footer" label-width="120px">-->
        <!--<el-button @click="dialogFormVisible = false">取消</el-button>-->
        <!--<el-button type="primary" @click="modifyStaffPassword(homeForm)">確認</el-button>-->
      <!--</div>-->
    </el-dialog>

    <el-col :span="24" class="main">
      <aside :class="collapsed?'menu-collapsed':'menu-expanded'">
        <!--導航菜單 "#4B78FFFF"  -->
    <!-- <el-menu v-if="$store.getters.ismobilePhone"  :default-active="onRoutes" @open="handleopen" @close="handleclose" @select="handleselect" unique-opened router :collapse="collapsed">
       <menu-tree :nodes="$router.options.routes" ></menu-tree>
     </el-menu>
	 -->
	 
	  <el-menu   background-color="#4B78FF"
	       text-color="#fff"
	       :default-active="onRoutes" @open="handleopen" @close="handleclose" @select="handleselect" unique-opened router :collapse="$store.getters.ismobilePhone==false?collapsed:false" ><!--:collapse="collapsed"-->
	      <!--   <menu-tree :nodes="$router.options.routes" ></menu-tree> -->
<!-- 	 <el-menu-item  v-if="!$store.getters.ismobilePhone" index="Homepage">
	         								         <img style="margin-left: -10px;"src="../../static/img/menuicon/icon_home.png"></img>
	         								        <span slot="title">首页</span>
	         								      </el-menu-item> 
												  #4B78FF
												 -->
												 
					 <div class="homeGlance" v-if="!$store.getters.ismobilePhone"  @click="tapClick(1)">
						  <div style="width: 70px;margin-left: 71px;padding-top: 10px;">倉庫一覽</div>
						  <div style="margin-left: 50px; margin-top: -18px;">  <img src="../../static/img/menuicon/icon_home.png"></img></div>
						 <!--  <span style="margin-left: 70px;margin-top: -20px;">倉庫一覽</span> -->
						  <!--../../static/img/menuicon/icon_home.png-->
						
						 </div>								  
												  
	 	 <el-submenu v-if="router.id&&!$store.getters.ismobilePhone&&router.id!=15" :index="i.toString()"  v-for="(router,i) in $router.options.routes" class="elmenu" :key="router.id">
	 		        			  <template slot="title">
									  <!--:src="require('../../static/img/menuicon/icon_home.png')"
									  
									  :src="'../../static/img/menuicon/'+router.icon"
									  -->
									 <img style="margin-left: -5px;" :src="'../../img/menuicon/'+router.icon"></img>
 		        			           <span>{{router.name}}</span>
	 		        			         </template>
	 		        				
	 		        					           
	 		        					           <el-menu-item style="border: 0px; background-color: #436DE2; font-size: 12rpx;width: 100%;"   v-for="childrens in router.children" :index="childrens.path.toString()"  :key="childrens.id" v-if="childrens.id!=25">{{childrens.name}}</el-menu-item>
	 		        					           
	 		        					     
	 		        			 </el-submenu>
								<!-- 手机端导航 -->
						

						 <!--  <el-menu-item  class="elmenu" v-if="$store.getters.ismobilePhone" v-for="(prouter,i) in phoneRoutes" :index="prouter.path.toString()" :key="prouter.id.toString()">
								       
								        <span slot="title">{{prouter.name}}</span>
								      </el-menu-item> -->
								    <!--  <el-menu-item class="elmenu" index="customer/" v-if="$store.getters.ismobilePhone" :key="3" >
								       
								        <span slot="title">客戶</span>
								      </el-menu-item>
								    <el-menu-item class="elmenu" index="taskCalendar/" v-if="$store.getters.ismobilePhone" :key="4">
								     
								      <span slot="title">任务日歷</span>
								    </el-menu-item>
								 --> 
								
								
							
						
							
								 
	 				
	 			<!-- 	</el-menu> -->
	 
    				
    				</el-menu>
				
				<!---->
     <!--   <el-menu active-text-color="#4B78FF"  style="overflow: hidden;" :default-active="onRoutes" @open="handleopen" @close="handleclose" @select="handleselect" unique-opened router :collapse="$store.getters.collapsed">
          <menu-tree :nodes="$router.options.routes" ></menu-tree>
        </el-menu>-->
      </aside>
	  <!--手机端tab-->
      <section class="content-container">
        <div class="grid-content bg-purple-light">
        <!--  <div class="tabsbg" id="faart" v-if="$store.getters.ismobilePhone">
            <template v-for="tab in tabs">
                  <span style=" margin-right:15px; margin-bottom:10px;    display: inline-block;   position: relative;">
                  <el-button   @click="toTab(tab)" size="medium" :type="$route.name==tab.name?'primary':'info'" circle  >{{tab.name}}</el-button>
				// <i class="el-icon-error" @click="colseTab(tab.name)" v-if="$route.name!=tab.name" style="position: absolute;right: -8px;top: -4px;"></i> 
				  
				   <img  @click="colseTab(tab.name)" v-if="$route.name!=tab.name" style="width: 12px; height: 12px; position: absolute;right: -5px;top: -8px;color: red;" src="../../static/img/closeX.png"></img>
				  
                  </span>
            </template>
          </div> -->
          <el-col :span="24" class="content-wrapper">
            <transition name="fade" mode="out-in">
              <keep-alive exclude="pro-mail-add-edit">
                <router-view></router-view>
              </keep-alive>
            </transition>
          </el-col> 
        </div>
      </section>
    </el-col>
  </el-row>
</template>

<script>
    import router from '@/router/router'
    import Role from '@/views/Role'
    import parseMenu from '@/utils/MenuUtil'
    import MenuTree from '@/components/MenuTree'
    import { getMenuTree,modifyStaffPassword,getLogout } from '../api/api'
    export default {

        data() {
//            var evt = "onorientationchange" in window ? "orientationchange" : "resize"
//            window.addEventListener(evt, function(){
//                alert(1);
//            },false);
        

            var checkPwd2 = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error("新密碼不能為空"));
                }else if (value.length<6||value.length>20){
                    callback(new Error("新密碼長度在6至20位之間"));
                } else if (value !== this.homeForm.password) {
                    callback(new Error("兩次輸入密碼不一致"));
                } else {
                    callback();
                }
            };
            return {
                windowWidth: 0,
                isActive:false,
                isActiveTwo:true,
                sysName:'ROYAL',
               collapsed:false,
			   colseTabid:-1,//关闭tabid
                logBg:true,
                dialogTableVisible: false,
                dialogFormVisible: false,
                conFirmPlaceholder:"",
                searchs:null,
                placeholder: "",
				indexTabName:"倉庫一覽",
				
                homeForm: {
                    region: '',
                    delivery: false,
                    resource: '',
                    desc: '',
                    password: '',
                    confirmPassword:''
                },
				   
		
            }
        },
        components:{
            MenuTree
        },

        beforeDestroy() {
            window.removeEventListener('resize', this.getWindowWidth);
        },
        methods: {
            getWindowWidth(event) {
                if(document.body.clientWidth<813){
                    this.$store.commit("setIsmobilePhone",true);
                }else{
                    this.$store.commit("setIsmobilePhone",false);
                }

            },
            search(){
                this.isActive = false;
                this.isActiveTwo = true;
//            location.href = "/location/locationByXY";
                this.$store.commit("setKeywords",this.searchs);
//                this.$store.commit("setSearchSte",true);
                this.$router.push({
                    name: '首頁搜尋網頁面',
                    params: {
                        keywords: this.searchs
                    }
                })
            },
			tapClick(i)
			{
				// console.log("etetert");
				if(i==1)
				{
					this.$router.push({
					    name: '倉庫一覽'
					})
				}
				else if(i==2)
				{
					this.$router.push({
					    name: '客戶'
					})
				}
				else
				{
					this.$router.push({
					    name: '行事曆'
					})
				}
				
			},
            logClick(){
                //this.$router.push('/');
                this.$store.commit("setSta",false);
                this.$store.commit("setIsLoding",true);
                this.$router.push({
                    name: '倉庫一覽'
                })
            },
            colseTab(name){
				// 	console.log(1234);
				 // console.log(i);
				    var i=this.tabs.findIndex(item=>item.name==name);
					this.colseTabid=i;
			
                this.$store.commit("closeTab",name);
            },
            toTab(value){
				// if(value.name!=this.$route.name)
				// {
					
                this.$router.push(value.url);
				
                this.$store.commit("setterClickTab",value.name);
				//}
					// this.selectTabName=value.name;
            },
            onSubmit() {
//        console.log('submit!');
            },
            handleopen() {
                console.log('handleopen');
				
            },
            handleclose() {
                console.log('handleclose');
            },
            handleselect (path, i) {
				console.log('handleselect');
				//选中子菜單，隐藏导航
				  this.collapsed=false;
				  this.colseTabid=-1;
                // console.log(path);
            },
            logout () {
                this.$confirm('是否退出', '提示', {
                    type: 'warning'
                }).then(() => {
//          console.log(router);
                    let  staffId=this.$store.getters.staff.id;
                    getLogout(staffId).then(data=>{
                        window.sessionStorage.removeItem("staff");
                        this.$router.options.routes.splice(2,router.options.routes.length-2);
                        this.$router.push('/login');
                    });
                }).catch(() => {

                });
            },
            updpwd(){
                this.homeForm.password='';
                this.homeForm.confirmPassword='';
               this.dialogFormVisible=true;
            },
            mobSer(){

                if(this.isActive == true && this.isActiveTwo == false){
                    this.isActive = false;
                    this.isActiveTwo = true;
                }else if(this.isActiveTwo == true && this.isActive == false){
                    this.isActive = true;
                    this.isActiveTwo = false;
                }
                this.$store.commit("setCollapsed",false);
            },
            //折疊巡覽列
            collapse(){
                this.collapsed=!this.collapsed;
				
                // if (this.collapsed){
                //     this.logBg=false;
                // }else {
                //     this.logBg=true;
                // }
              /* this.collapsed=!this.collapsed;
                if(this.$store.getters.collapsed == false){
                    this.$store.commit("setCollapsed",true);
                }else{
                    this.$store.commit("setCollapsed",false);
                }*/

                this.isActive = false;
                this.isActiveTwo = true;
//                if (this.collapsed){
//                    this.logBg=false;
//                }else {
//                    this.logBg=true;
//                }
            },
            //修改密碼
            modifyStaffPassword(formName){

                let str = this.isNull();
                if(str !== ""){
                    this.dialogVisible =true;
                    this.$alert(str, '提示', {
                        confirmButtonText: '確定',
                        type: 'error'
                    });
                }else {
                    this.$refs.homeForm.validate((valid) => {
                        if (valid) {
                            return modifyStaffPassword(this.homeForm.password).then(data => {
                                let {data: res = {}} = data;
                                if (res.errcode == 200) {
                                    this.$message({
                                        message: "修改成功",
                                        type: 'success'
                                    });
                                    this.dialogFormVisible = false;
                                    this.homeForm.password = '';
                                    this.homeForm.confirmPassword = '';
                                } else {
                                    this.$message({
                                        message: "修改失敗",
                                        type: 'warning'
                                    });
                                }
                            });
                        }
                    });
                }
            },
            isNull(){/*是否为空*/
                if(this.homeForm.password ==="" || this.homeForm.password === null){
                    return "請輸入新密碼"
                }
                if(this.homeForm.password.length <6 || this.homeForm.password.length > 20){
                    return "輸入新密碼長度在6至20之間"
                }
                if(this.homeForm.confirmPassword ==="" || this.homeForm.confirmPassword === null){
                    return "請確認新密碼"
                }
                if(this.homeForm.confirmPassword.length <6 || this.homeForm.confirmPassword.length > 20){
                    return "確認密碼長度在6至20之間"
                }
                if (this.homeForm.password !== this.homeForm.confirmPassword) {
                    return "兩次輸入密碼不一致";
                }
                return "";
            },
        },
        computed: {
            valDataType(){
                return document.body.clientWidth;
            },
            staff(){
                return this.$store.getters.staff;
            },
            routes(){
                console.log("routes",this.$router.options.routes)
                return this.$router.options.routes;
            },
            tabs(){
            
                return this.$store.getters.tabs;
            },
            onRoutes(){
				  
				  if(this.colseTabid==-1||this.colseTabid==0)
				  {
					   // console.log("tabs22222",this.$route.name)
					   //  console.log("tabs444",this.selectTabName)
					this.$store.commit("addTab",{name:this.$route.name,url:this.$route.path});
					this.$store.commit("setterClickTab",this.$route.name);
					return "/"+this.$route.path; 
				
				  }
				  else
				  {
					  
					  this.$router.push({
					      name: this.tabs[this.tabs.length-1].name,
					     
					  })
					 //  this.$store.commit("addTab",{name:this.tabs[this.tabs.length-1].name,url:this.tabs[this.tabs.length-1].url});
					 // this.$store.commit("setterClickTab",this.tabs[this.tabs.length-1].name);
					 //  console.log("tabs333",this.tabs[this.tabs.length-1].url)
					 // return "/"+this.tabs[this.tabs.length-1].url;  
				  }
				 // else
				 // {
					 
					//  this.$store.commit("addTab",{name:this.tabs[this.tabs.length-1],url:this.tabs.path});
					//  this.$store.commit("setterClickTab",this.tabs.name);
					//  return "/"+this.tabs.path; 
				 // }
               

            }
        },
        created(){
            /* console.log("============>>created");*/
        },
        beforeRouteEnter (to, from, next) {
            /*console.log("============>>beforeRouteEnter");*/
            next();
        },
        beforeMount(){
            /*console.log("============>>beforeMount");*/
        },
        mounted() {
            this.$nextTick(function() {
                window.addEventListener('resize', this.getWindowWidth);
                //Init
                this.getWindowWidth()
            })
            if(document.body.clientWidth<813){
                this.$store.commit("setIsmobilePhone",true);
            }else{
                this.$store.commit("setIsmobilePhone",false);
            }
            this.logClick();

        },
    }



</script>

<style scoped lang="scss">
  .el-form-item {
    margin-bottom: 5px;
  }
 // .el-menu--horizontal > .el-menu-item {
 //   width: 50%;
 //   border-bottom: none;
 //   height: 1rem;
 //   line-height: 0.5rem;
 //   text-align: center;
 // }
 // .el-menu--horizontal > .el-menu-item.is-active {
 //   border-bottom: none;
 // }
 

  .tabsbg{
     // margin-bottom: 5px;
      margin-top: -5px;
	// height: 120px;
	
    background:#ffffff;
     border-bottom: 1px solid #ddd;
  }
  
  // #faart{ margin-bottom:20px;}
  
.elmenu
{
	text-align: center;
	
	
}
.homeGlance
{
background-color:#4B78FF;
 height: 40px; 
 color: white;
 font-size: 12px;
  margin-left: -37px;
  cursor:pointer;//鼠标放上去变为手指
}
.homeGlance:hover
{
	background-color:#436DE2;
}
  .ssf{background: #fff;
    color: #000;
    border-radius: 0px;
    border: 1px solid #ddd;
    position: absolute;
    bottom: -14px;
    border-bottom: 1px solid #fff;
    border-top: 2px solid #228569;}

  .container {
    position: absolute;
    top: 0px;
    bottom: 0px;
    width: 100%;
    .header {
      height: 80px;
      line-height: 80px;
    
      border-bottom:1px solid #ddd;
	  
     
	   // background: -moz-linear-gradient(top, #32825b 0%, #175035 100%);
    //     background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,#32825b), color-stop(100%,#175035));
    //     background: -webkit-linear-gradient(top, #32825b 0%,#175035 100%);
    //     background: -o-linear-gradient(top, #32825b 0%,#175035 100%);
    //     background: -ms-linear-gradient(top, #32825b 0%,#175035 100%);
    //     background: linear-gradient(top, #32825b 0%,#175035 100%);
      color:#fff;
      .topmenu {
        text-align: right;
        padding-right: 30px;
        float: right;
        .item{
          color: #000;
          .mark{
            font-size: 12px;
            background: rgba(0, 0, 0, 0.5);
            color: #fff;
            margin: -10px 6px 0;
            min-width: 8px;
            text-align: center;
            border-radius: 0.6rem;
            padding: .25em .5em;
          }
        }
        .userinfo-inner {
          cursor: pointer;
          color:#333;
          img {
            width: 40px;
            height: 40px;
            border-radius: 20px;
            margin: 10px 0px 10px 10px;
            float: right;
          }
          i{
            color:#fff;
          }
        }
      }

      .logo {
        height:60px;
        font-size: 15px;
		
      
        // padding-right:10px;
		

        img {
          width: 155px;
          float: left;
           margin: 5px 10px 10px 2px;
        }
      }
      .logo-width{
        width:144px;
        cursor: pointer;
      }
      .logo-collapse-width{
      /*  width:65px;*/
        cursor: pointer;
      }
      .tools{
        padding: 0px 23px;
        width:14px;
        height:90px;
        line-height:90px;
        cursor: pointer;
        i{
          color:#666;
        }
      }
    }
    .main {
      display: flex;
      position: absolute;
      top: 82px;
      bottom: 0px;
	  
      overflow: hidden;
      aside {
        flex:0 0 144px;
        width: 144px;
        .el-menu{
          height: 100%;
        }
      }
      .menu-collapsed{
        flex:0 0 60px;
        width: 60px;
      }
      .menu-expanded{
        flex:0 0 144px;
        width: 144px;
      }
      .content-container {
        flex:1;
        overflow-y: scroll;
        padding: 20px;
		
        .breadcrumb-container {
          border: solid 1px #e9e9e9;
          margin: 0 0 20px;
          padding: 10px;
          background: #ffffff;
          background: -moz-linear-gradient(top, #ffffff 0%, #f5f5f5 100%);
          background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,#ffffff), color-stop(100%,#f5f5f5));
          background: -webkit-linear-gradient(top, #ffffff 0%,#f5f5f5 100%);
          background: -o-linear-gradient(top, #ffffff 0%,#f5f5f5 100%);
          background: -ms-linear-gradient(top, #ffffff 0%,#f5f5f5 100%);
          background: linear-gradient(top, #ffffff 0%,#f5f5f5 100%);
          filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#f5f5f5',GradientType=0 );
          -webkit-border-radius: 4px;
          -moz-border-radius: 4px;
          -ms-border-radius: 4px;
          border-radius: 4px;
		 
        }
        .content-wrapper {
          //background-color: #fff;
          box-sizing: border-box;
        }
      }
    }
  }
  .el-col-6{width:auto;}
  
  .active{display: block}
  .activeTwo{display: none}
</style>




// WEBPACK FOOTER //
// src/views/Home.vue